import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloudUpload } from 'lucide-react';
import { useIngest } from '../hooks/useIngest';

export function UploadDropzone() {
  const { t } = useTranslation();
  const { ingest } = useIngest();
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      setDragOver(false);
      const files = Array.from(e.dataTransfer.files).filter((f) =>
        f.type.startsWith('video/'),
      );
      if (files.length) ingest(files);
    },
    [ingest],
  );

  const handleFileInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = Array.from(e.target.files ?? []);
      if (files.length) ingest(files);
      e.target.value = '';
    },
    [ingest],
  );

  return (
    <button
      type="button"
      onClick={() => fileInputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={handleDrop}
      className={`flex w-full items-center justify-center gap-2 px-3 py-2 rounded-xl transition-all cursor-pointer ${
        dragOver
          ? 'bg-[rgba(7,229,176,0.15)]'
          : 'bg-[var(--user-page-card-bg)] hover:brightness-125'
      }`}
      style={{
        border: dragOver ? '1px solid var(--user-page-accent)' : '1px solid var(--user-page-card-border)',
      }}
    >
      <CloudUpload size={16} style={{ color: 'var(--user-page-accent)' }} />
      <span className="text-xs font-semibold" style={{ color: 'var(--user-page-accent)' }}>
        {t('editor.upload', 'Upload')}
      </span>
      <input
        ref={fileInputRef}
        type="file"
        accept="video/*"
        multiple
        onChange={handleFileInput}
        className="hidden"
      />
    </button>
  );
}
